import type { ReactLocalization } from "@fluent/react";
import finance from "byzantine/src/finance";
import type { RowEdit, RowErrors } from "./recipientReviewTypes";

export const validateField = (
  l10n: ReactLocalization,
  field: string,
  value: string
): string | null => {
  const trimmed = value.trim();
  if (!trimmed) {
    return l10n.getString("recipient-review-validation-required");
  }
  switch (field) {
    case "account_number":
      if (!/^\d+$/.test(trimmed)) {
        return l10n.getString("recipient-review-validation-numeric");
      }
      if (trimmed.length > 17) {
        return l10n.getString("recipient-review-validation-account-max");
      }
      break;
    case "routing_number":
      if (!/^\d{9}$/.test(trimmed)) {
        return l10n.getString("recipient-review-validation-routing-invalid");
      }
      if (!finance.abaRoutingNumberIsValid(trimmed)) {
        return l10n.getString("recipient-review-validation-routing-invalid");
      }
      break;
    case "account_type":
      if (trimmed !== "checking" && trimmed !== "savings") {
        return l10n.getString("recipient-review-validation-type-invalid");
      }
      break;
    default:
      break;
  }
  return null;
};

export const validateRow = (
  l10n: ReactLocalization,
  edit: RowEdit
): RowErrors => {
  const errors: RowErrors = {};
  (
    [
      ["recipient_name", "name"],
      ["account_number", "account_number"],
      ["routing_number", "routing_number"],
      ["account_type", "account_type"],
    ] as [keyof RowEdit, string][]
  ).forEach(([field, fieldKey]) => {
    const error = validateField(l10n, fieldKey, edit[field]);
    if (error) {
      errors[fieldKey] = error;
    }
  });
  return errors;
};
